import request from '@utils/request'
import { groupById } from '@utils/normalize-data'

export const state = {
  cached: [],
  byId: {},
}

export const getters = {}

export const mutations = {
  CACHE_PRODUCTS(state, currentProducts) {
    state.cached = currentProducts
    state.byId = groupById(currentProducts, 'products')
  },
}

export const actions = {
  fetchPrices({ commit }, { productId, query }) {
    return request
      .post(`/admin/product/${productId}/price/search`, {
        paginate: 0,
        ...query,
      })
      .then((response) => response.items)
  },
  storePrices({ commit }, { productId, storeData }) {
    return request.post(`/admin/product/${productId}/price/store`, {
      params: storeData,
    })
  },
  inventoryCalendar({ commit }, { productId, submitData }) {
    return request.post(`/admin/product/${productId}/calendar`, submitData)
  },
  store({ commit }, storeData) {
    return request
      .post('/admin/product/store', storeData)
      .then((response) => response && response.items)
  },
  updateState({ commit }, { ids, state } = {}) {
    return request.post('/admin/product/state', { ids, state })
  },
  remove({ commit }, { ids }) {
    return request.post('/admin/product/remove', { ids })
  },
  fetchSingle({ commit }, productId) {
    return request
      .get(`/admin/product/${productId}`)
      .then((response) => response.items)
  },
  fetchList({ commit }, query) {
    return request
      .post('/admin/product/search', query)
      .then(({ items, pagination: { total } }) => {
        commit('CACHE_PRODUCTS', items)
        return {
          items,
          total,
        }
      })
  },
  updateExtraField({ commit }, submitData ) {
    return request
      .post(`/admin/product/order/extrafield/store`, submitData)
      .then((response) => response.items)
  },
  fetchExtraField({ commit }, query ) {
    return request
      .post('/admin/product/order/extrafield/search', query)
      .then((response) => response.items)
  },
}
